import Vue from "vue";
import { date } from "@/utils/tools";
import { certificateItem, approverItem } from "./filters";

Vue.filter("date", date);
Vue.filter("certificateItem", certificateItem);
Vue.filter("approverItem", approverItem);



// WEBPACK FOOTER //
// ./src/filter/index.js